/**
 * Sources API - работа с источниками открыток
 */
import { request } from '../utils/fetchClient';

/**
 * Получить список источников
 * @param {Object} params
 * @param {string} params.type - Фильтр: author, website, telegram, pinterest
 * @param {number} params.limit
 * @param {number} params.offset
 * @param {string} params.sort - images_count, name, created_at
 */
export const getSources = async ({ type, limit = 100, offset = 0, sort = 'images_count' } = {}) => {
    const params = new URLSearchParams({ limit, offset, sort });
    if (type) params.set('type', type);
    return request(`/sources?${params}`);
};

/**
 * Получить количество источников по типам (для навигации)
 */
export const getSourceTypes = async () => {
    return request('/sources/types');
};

/**
 * Получить источник по ID открытки (relation)
 * @param {number} relationId - ID открытки
 */
export const getSourceByRelationId = async (relationId) => {
    return request(`/sources/by-relation/${relationId}`);
};

/**
 * Получить источник по ID
 * @param {number} sourceId
 */
export const getSourceById = async (sourceId) => {
    return request(`/sources/${sourceId}`);
};

/**
 * Получить открытки источника
 * @param {number} sourceId
 * @param {Object} params
 */
export const getSourceImages = async (sourceId, { limit = 50, offset = 0 } = {}) => {
    const params = new URLSearchParams({ limit, offset });
    return request(`/sources/${sourceId}/images?${params}`);
};

// === Admin CRUD ===

export const getAdminSources = async ({ type, search, limit = 200, offset = 0 } = {}) => {
    const params = new URLSearchParams({ limit, offset });
    if (type) params.set('type', type);
    if (search) params.set('search', search);
    return request(`/sources/admin/all?${params}`);
};

export const createSource = async (data) => {
    return request('/sources', { method: 'POST', body: JSON.stringify(data), headers: { 'Content-Type': 'application/json' } });
};

export const updateSource = async (sourceId, data) => {
    return request(`/sources/${sourceId}`, { method: 'PUT', body: JSON.stringify(data), headers: { 'Content-Type': 'application/json' } });
};

export const deleteSource = async (sourceId) => {
    return request(`/sources/${sourceId}`, { method: 'DELETE' });
};

export const recountSource = async (sourceId) => {
    return request(`/sources/${sourceId}/recount`, { method: 'POST' });
};

export const recountAllSources = async () => {
    return request('/sources/admin/recount-all', { method: 'POST' });
};
